import { Link, useNavigate } from "react-router-dom";
import "../Css/supprtMessage.css";
import axios from "axios";

function SupportMessage({ type, message, options, onOptionClick , finalMessage,sellers_id,sellers_links ,order_id}) {
  
  const isSupport = type === 1;
  const token = JSON.parse(localStorage.getItem('userToken'));
  const config = {  headers: {"Content-Type": "application/json", Authorization: `Bearer ${token}`} };
  const navigate = useNavigate();



  // وقتی کاربر یکی از فروشنده ها رو انتخاب میکنه
  const sellerPicked = async (seller,index) =>
  {
    //کاربر به واتساپ فروشنده وصل میشه
    window.open(sellers_links[index], "_blank");

    //آیدی فروشنده به عنوان فروشنده منتخب تو سفارش دخیره میشه
    if(order_id)
      await axios.patch(process.env.REACT_APP_BACK + "/orders/add-chosen-seller/"+order_id+"/"+seller._id, config)
                        .then((res) => {
                            
                        })
                        .catch((error) => {
                            if (error.response.data.statusCode === 401)
                                navigate("/login")
                        });


    // پیامک اطلاع رسانی به مدیر ارسال میشه
    var d = JSON.stringify({
                            "code": "ovu8lf8janqjc4v",
                            "sender": "+983000505",
                            "recipient": "09352333881",
                            "variable": {
                              "verification-code": seller.name
                            }
                          });
      
      var config = {
            method: 'post',
            url: 'https://api2.ippanel.com/api/v1/sms/pattern/normal/send',
            headers: { 
              'apikey': 'bv1PxCuaPVZUcIPOSqgmx7u9w8nzdBk1Boj_vnwvo48=', 
              'Content-Type': 'application/json'
            },
            data : d
          };

          axios(config)
          .then(function (response) {
                  
                  if(response.status === 200)
                  {
                   
                  }
                  
                })
                .catch(function (error) {
                  console.log("error",error);
                
                });

  }

  return (

    <div className={`support-message ${isSupport ? "support slide-in-right" : "client slide-in-left"}`}>




      {true && (
        <img
           src={ isSupport ? require('../images/logo.png') : 
                            `${process.env.REACT_APP_BACK}/avatars/customer_avatar.png`}
          alt="Support"
          className="avatar"
        />
      )}
      <div className= {!finalMessage?  "bubble" : "bubble finalMessage"}>
        {message}

        {/* نمایش گزینه‌ها به صورت دکمه داخل همین حباب */}
        {isSupport && options && options.length > 0 && (
          <div className="options-list">
            {options.map((opt, i) => (
              <span key={opt.label}>


              {!finalMessage ? 


              <button
                key={i}
                className={opt.label==="بذار خودم توضیح بدم" ? "customer-choice option-button" : "option-button"}
                onClick={() => onOptionClick(opt)}
              >
                {opt.label}
              </button>

              :

              <div>

                {sellers_id.length !== 0 ?

              <button
                key={i}
                className={"sellerslist"}
                
              >
                {/* نمایش اطلاعات فروشندگان */}
                <div>
                            {sellers_id.map( (seller,index) => { return <span  key={index}>
                            
                             
                             
                             <span className="sellerrow" 
                             onClick={()=>sellerPicked(seller,index)}>

                                <img 
                                src={`${process.env.REACT_APP_BACK}/avatars/${seller.avatarPic}`}
                                style={{height:"40px",width:"40px",borderRadius:"50%"}}></img>

                                <div style={{margin:"0px 10px"}}>
                                  <h6 style={{marginRight:"10px"}}>{seller.name}</h6>
                                  <p>{seller.description.length > 20 ? seller.description.substring(0, 70) + "..." : seller.description}</p>

                                </div>
                                
                                
                              </span>
                            
                            
                            </span>
                            })
                            }
                        </div>
              </button>


            :

              <button className="noseller">متاسفانه هیچ کدوم از فروشگاه هامون محصول شما رو موجود ندارن:(
              </button>

                          }

              </div>

              }
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default SupportMessage;
